import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const RATES_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('RATES');
export const RATES_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(RATES_CRUD_ACTION_CONSTANTS);
